import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional className helper for shadcn-style components.
 * Combines clsx semantics with tailwind-merge's conflict resolution
 * so later Tailwind classes win over earlier ones in variants.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
